import { ChangeEvent, KeyboardEvent, useMemo, useState } from 'react'

import { useDidMountEffect, useQueryList } from '@percent/partner-dashboard/common/hooks'
import { useServices } from '@percent/partner-dashboard/context/serviceContext/ServiceContext'
import { GetGivingActionsListProps } from '@percent/partner-dashboard/services/givingActions/givingActionsService.types'

const PAGE_SIZE = 10

export const useGivingActionsTable = () => {
  const { givingActionsService } = useServices()

  const [searchValue, setSearchValue] = useState('')
  const [searchQuery, setSearchQuery] = useState('')

  const listParams = useMemo<GetGivingActionsListProps>(
    () => ({
      pageSize: PAGE_SIZE,
      ...(searchQuery && { query: searchQuery })
    }),
    [searchQuery]
  )

  const [{ data, isLoading, errorMessage, totalResults }, { query, nextPage, previousPage, refresh }] = useQueryList(
    givingActionsService.getGivingActionsList,
    listParams
  )

  useDidMountEffect(() => query(listParams), [listParams, query])

  const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => setSearchValue(event.target.value)

  const handleSearchKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      setSearchQuery(searchValue.trim())
    }

    if (event.key === 'Escape') {
      setSearchValue('')
      setSearchQuery('')
    }
  }

  const handleSearchClear = () => {
    setSearchValue('')
    setSearchQuery('')
  }

  return {
    data,
    isLoading,
    errorMessage,
    totalResults,
    nextPage,
    previousPage,
    refresh,
    searchValue,
    searchQuery,
    handleSearchChange,
    handleSearchKeyDown,
    handleSearchClear
  }
}
